var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2882",
    "data-name": "Group 2882",
    transform: "translate(-140 -2278)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1311",
    "data-name": "Rectangle 1311",
    width: 24,
    height: 24,
    transform: "translate(140 2278)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(9.252 2154.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon6",
    transform: "translate(131.969 125.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2112",
    "data-name": "Group 2112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1689",
    "data-name": "Path 1689",
    d: "M-4.823-18.547H13.483m-.2-1.488L4.33-24.8l-8.955,4.766ZM-4.336-9.271H13M-5.334-7.582H14M-6.449-5.892H15.11M-3.065-18.5v9.229M-.837-18.5v9.229M3.049-18.5v9.229M5.278-18.5v9.229M9.164-18.5v9.229M11.392-18.5v9.229",
    transform: "translate(6.449 24.8)",
    fill: "none",
    stroke: "#6db3e0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.3a72fda221ec7f5a6e63d33f4a2c2e44.svg";
export { ForwardRef as ReactComponent };